import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

/** Hairline rule in the sand tone. Decorative, so hidden from assistive tech. */
export function Separator({
  className,
  orientation = 'horizontal',
  ...props
}: HTMLAttributes<HTMLDivElement> & { orientation?: 'horizontal' | 'vertical' }) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn(
        'shrink-0 bg-sand-300',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      )}
      {...props}
    />
  );
}

/** Loading placeholder. Always pair with an `aria-busy` region or sr-only text. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-shimmer animate-shimmer rounded-xl', className)}
      aria-hidden="true"
      {...props}
    />
  );
}

/** Visible only to screen readers — for headings that would be visual noise. */
export function VisuallyHidden({ children }: { children: React.ReactNode }) {
  return <span className="sr-only">{children}</span>;
}
